import { getBuildingGroupOptions } from '../../../api'
import { useAsyncCallback } from '../../../hooks'
import {
  EntityAsyncMultiValuedInfiniteListMoreItems,
  EntityMultiValuedListMoreItem,
} from '../../Entity'
import { MultiValuedList } from '../../MultiValuedList'
import { TextMultiValuedListItem } from '../../TextMultiValuedList'

import { getDataItems } from './BuildingGroupAsyncMultiValuedList.utils'

function BuildingGroupAsyncMultiValuedList({
  Item = TextMultiValuedListItem,
  MoreItem = EntityMultiValuedListMoreItem,
  MoreItems = EntityAsyncMultiValuedInfiniteListMoreItems,
  apiParams,
  ...restProps
}) {
  const handleLoadData = useAsyncCallback(params => {
    return getBuildingGroupOptions(params)
  }, [])

  return (
    <MultiValuedList
      {...restProps}
      Item={Item}
      MoreItem={MoreItem}
      MoreItems={MoreItems}
      moreItemsProps={{
        apiParams,
        getData: handleLoadData,
        getDataItems,
      }}
    />
  )
}

export default BuildingGroupAsyncMultiValuedList
